<template>
  <section v-if="waitingRoomActive">
    <v-table
      url="/api/v1/dialog/waiting-room-dialogs"
      :attributes="[
        {
          attribute: 'customer',
          name: 'Mitglied',
          type: customerCell,
          sortable: false
        },
        {
          attribute: 'fake',
          name: 'Fake',
          type: customerCell,
          sortable: false
        },
        {
          attribute: 'dialog_id',
          name: 'Dialog',
          type: 'DialogInfoCell',
          sortable: false
        },
        {
          attribute: 'waitingroom_user',
          name: 'Hinzugefügt von',
          type: 'UserNoEmailCell',
          sortable: false
        },
        {
          attribute: 'updated_at',
          name: 'Dauer im Wartezimmer',
          type: 'TimeCounterCell',
          sortable: false
        },
        {
          attribute: 'last_message_at',
          name: 'Letzte Mitgliedsnachricht vor',
          type: 'TimeCounterCell',
          sortable: false
        },
        {
          name: 'Aktionen',
          type: 'WaitingroomDialogActionCell',
          sortable: false
        }
      ]"
      ref="table"
      @table-fetched="tableFetched"
    >
      <div slot="title">
        Dialoge im Wartezimmer
      </div>
    </v-table>
  </section>
</template>

<script lang="babel">
import { bus } from "@/bus";
export default {
  data() {
    return {
      fetchInterval: null,
      canFetch: true,
      waitingRoomActive: false
    }
  },
  created() {
    this.waitingRoomActive = Boolean(Laravel.settings.enableWaitingRoom);
    bus.$on("waiting-room-disable", () => {
      this.waitingRoomActive = false;
    });
  },
  mounted() {
    this.$bus.$on("waiting-room-dialogs-update", () => this.fetch());

    this.fetchInterval = setInterval(() => {
      this.fetch();
    }, 3500);
    this.fetch();
  },
  beforeDestory() {
    clearInterval(this.fetchInterval);
  },
  methods: {
    fetch() {
      if (this.canFetch && this.$refs.table) {
        this.canFetch = false;
        this.$refs.table.fetch().finally(() => this.canFetch = true);
      }
    },
    tableFetched() {
      this.$emit("count-update", this.$refs.table.count);
    }
  },
  computed: {
    customerCell() {
       return Laravel.user.roles.some(el => el.name === "agency_leader") ?
          'CustomerCell' : 'LinkProfileCell';
    },
  },
};
</script>
